package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

import waldo.sankan.lineamunicipalkmp.model.Comuna
import waldo.sankan.lineamunicipalkmp.model.Administrador

@Composable
fun AgregarServicioModal(
    admin: Administrador?,
    comunas: List<Comuna>,
    onDismiss: () -> Unit,
    onConfirm: (nombre: String, nombreDisplay: String, departamento: String, comunaRef: String?, comunaNombre: String?) -> Unit
) {
    var nombreId by remember { mutableStateOf("") }
    var nombreDisplay by remember { mutableStateOf("") }
    
    val esGeneral = admin?.rol == "GENERAL"
    
    // 🛡️ REGLA DE ORO SANKAN: Detección inteligente de Dirección basada en Rol
    val deptoInicial = when {
        admin?.rol?.contains("DAO") == true -> "DAO"
        admin?.rol?.contains("SEGURIDAD") == true -> "SEGURIDAD"
        admin?.rol?.contains("SOCIAL") == true -> "SOCIAL"
        admin?.rol?.contains("TURISMO") == true || admin?.rol?.contains("SALVAV") == true -> "TURISMO"
        else -> "DAO"
    }
    
    var departamentoSeleccionado by remember { mutableStateOf(deptoInicial) }
    
    // Comuna seleccionada (solo para ADMIN_GENERAL)
    var comunaSeleccionadaRef by remember { mutableStateOf(admin?.comunaAsignadaRef ?: "") }
    var comunaSeleccionadaNombre by remember { mutableStateOf(admin?.comunaAsignadaDisplayName ?: "") }

    val departamentos = listOf("DAO", "SEGURIDAD", "SOCIAL", "TURISMO")

    // Capa de fondo oscura (Overlay)
    Div({
        style {
            position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
            backgroundColor(rgba(0, 0, 0, 0.6))
            display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
            property("z-index", "1200")
        }
    }) {
        // Caja de contenido
        Div({
            style {
                width(500.px); backgroundColor(Color.white); borderRadius(12.px); padding(32.px)
                display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(20.px)
                property("box-shadow", "0px 4px 12px rgba(0, 0, 0, 0.2)")
                property("max-height", "90vh"); property("overflow-y", "auto")
            }
        }) {
            H2({ style { marginTop(0.px); color(Color("#1976D2")); textAlign("center") } }) {
                Text("Desplegar Nuevo Servicio")
            }

            // --- SELECCIÓN DE COMUNA (SOLO GENERAL) ---
            if (esGeneral) {
                Div {
                    Label(attrs = { style { fontWeight("bold"); display(DisplayStyle.Block); marginBottom(8.px); color(Color("#D32F2F")) } }) {
                        Text("📍 ASIGNAR A COMUNA (Modo Maestro):")
                    }
                    Select({
                        style {
                            padding(14.px); fontSize(16.px); width(100.percent);
                            borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#D32F2F"))
                        }
                        onChange { event ->
                            val selectedComuna = comunas.find { it.id == event.value }
                            comunaSeleccionadaRef = event.value ?: ""
                            comunaSeleccionadaNombre = selectedComuna?.comunaDisplayName ?: ""
                        }
                    }) {
                        Option("", attrs = { if (comunaSeleccionadaRef == "") selected() }) { Text("-- Seleccione Comuna Destino --") }
                        comunas.forEach { comuna ->
                            Option(comuna.id, attrs = { if (comunaSeleccionadaRef == comuna.id) selected() }) {
                                Text(comuna.comunaDisplayName)
                            }
                        }
                    }
                }
            }

            // --- SELECCIÓN DE DIRECCIÓN (DEPARTAMENTO) ---
            Div {
                Label(attrs = { style { fontWeight("bold"); display(DisplayStyle.Block); marginBottom(8.px); color(Color("#1976D2")) } }) {
                    Text("Direcci\u00F3n Responsable:")
                }
                Select({
                    style {
                        padding(14.px); fontSize(16.px); width(100.percent);
                        borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#1976D2"));
                        backgroundColor(Color.white); outline("none")
                    }
                    // 🛡️ REPARACIÓN SANKAN: Habilitamos plenamente para el Admin Comunal.
                    // Quitamos cualquier restricción que lo deje 'muerto'.
                    onChange { event -> 
                        console.log("Direcci\u00F3n cambiada a: ${event.value}")
                        departamentoSeleccionado = event.value ?: "DAO" 
                    }
                }) {
                    departamentos.forEach { depto ->
                        val displayDepto = when(depto) {
                            "DAO" -> "Direcci\u00F3n de Aseo y Ornato (DAO)"
                            "SEGURIDAD" -> "Direcci\u00F3n de Seguridad Ciudadana"
                            "SOCIAL" -> "Direcci\u00F3n de Desarrollo Social"
                            "TURISMO" -> "Direcci\u00F3n de Turismo y Playas"
                            else -> "Direcci\u00F3n: $depto"
                        }
                        Option(depto, attrs = { 
                            if (departamentoSeleccionado == depto) selected() 
                        }) { Text(displayDepto) }
                    }
                }
            }

            // Campo 1: Nombre ID (Interno)
            Div {
                Label(attrs = { style { fontWeight("bold"); display(DisplayStyle.Block); marginBottom(8.px) } }) {
                    Text("Identificador Clave (Ej: bache, luminaria):")
                }
                Input(type = InputType.Text, attrs = {
                    value(nombreId)
                    placeholder("ej: aseo_adulto_mayor")
                    style {
                        padding(14.px); fontSize(16.px); width(100.percent);
                        boxSizing("border-box"); border(1.px, LineStyle.Solid, Color.lightgray);
                        borderRadius(6.px); outline("none")
                    }
                    onInput { event -> nombreId = event.value.lowercase().replace(" ", "_") }
                })
            }

            // Campo 2: Nombre Display (Público)
            Div {
                Label(attrs = { style { fontWeight("bold"); display(DisplayStyle.Block); marginBottom(8.px) } }) {
                    Text("Nombre Visible en la App:")
                }
                Input(type = InputType.Text, attrs = {
                    value(nombreDisplay)
                    placeholder("Ej: Seguridad Adulto Mayor")
                    style {
                        padding(14.px); fontSize(16.px); width(100.percent);
                        boxSizing("border-box"); border(1.px, LineStyle.Solid, Color.lightgray);
                        borderRadius(6.px); outline("none")
                    }
                    onInput { event -> nombreDisplay = event.value }
                })
            }

            // Botonera de Acción
            Div({
                style { display(DisplayStyle.Flex); justifyContent(JustifyContent.End); gap(16.px); marginTop(10.px) }
            }) {
                Button(attrs = {
                    onClick { onDismiss() }
                    style {
                        padding(12.px, 24.px); backgroundColor(Color("#E0E0E0"));
                        color(Color.black); border(0.px); borderRadius(8.px); cursor("pointer")
                    }
                }) { Text("Cancelar") }

                Button(attrs = {
                    val canConfirm = nombreId.isNotBlank() && nombreDisplay.isNotBlank() && (comunaSeleccionadaRef.isNotBlank() || !esGeneral)
                    onClick { 
                        if (canConfirm) onConfirm(nombreId, nombreDisplay, departamentoSeleccionado, comunaSeleccionadaRef, comunaSeleccionadaNombre) 
                    }
                    if (!canConfirm) disabled()
                    style {
                        padding(12.px, 24.px);
                        backgroundColor(if (canConfirm) Color("#34A853") else Color.lightgray);
                        color(Color.white); border(0.px); borderRadius(8.px);
                        cursor(if (canConfirm) "pointer" else "not-allowed");
                        fontWeight("bold")
                    }
                }) { Text("Desplegar Servicio") }
            }
        }
    }
}
